exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table td[data-v-3cdb7b32],.table th[data-v-3cdb7b32]{vertical-align:middle;text-align:center}.box[data-v-3cdb7b32]{border:1px solid #ddd;padding:1rem;border-radius:8px;background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cdb7b32","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/ContainerTable.vue
// module id = 1522
// module chunks = 0